import { render, staticRenderFns } from "./song.vue?vue&type=template&id=1c3da9b0&scoped=true"
import script from "./song.vue?vue&type=script&lang=js"
export * from "./song.vue?vue&type=script&lang=js"
import style0 from "./song.vue?vue&type=style&index=0&id=1c3da9b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3da9b0",
  null
  
)

export default component.exports